import { useEffect } from "react";
import { useForm } from "react-hook-form";
import styles from '../../../../styles/NavigationLogs.module.css';

export interface FilterValues {
  searchTerm?: string;
  type?: string;
  userId?: string;
  date?: string;
}

interface FiltersProps {
  onChange: (values: FilterValues) => void;
  users: { id: string; name: string }[];
}

export const Filters = ({ onChange, users }: FiltersProps) => {
  const { register, watch, reset } = useForm<FilterValues>();
  const values = watch();

  useEffect(() => {
    const delay = setTimeout(() => onChange(values), 400);
    return () => clearTimeout(delay);
  }, [JSON.stringify(values)]);

  return (
    <div className={styles.filterBar}>
      <SearchIcon />

      <input
        className={styles.filterInput}
        type="search"
        aria-label="Pesquisar registos"
        placeholder="Pesquisar por página, acção, email, IP..."
        {...register("searchTerm")}
      />

      <select className={styles.filterSelect} aria-label="Filtrar por tipo" {...register("type")}>
        <option value="">Todos os tipos</option>
        <option value="NAVIGATION">Navegação</option>
        <option value="API">API</option>
        <option value="ERROR">Erro</option>
      </select>

      <select className={styles.filterSelect} aria-label="Filtrar por utilizador" {...register("userId")}>
        <option value="">Todos os utilizadores</option>
        {users.map((u) => (
          <option key={u.id} value={u.id}>
            {u.name}
          </option>
        ))}
      </select>

      {/* <input
        className={styles.filterInput}
        style={{ minWidth: 140 }}
        type="date"
        {...register("date")}
      /> */}

      <button
        className={styles.clearBtn}
        type="button"
        aria-label="Limpar filtros"
        onClick={() => reset()}
      >
        Limpar
      </button>
    </div>
  );
};

function SearchIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false" className={styles.searchIcon}>
      <circle cx="6" cy="6" r="4" stroke="currentColor" strokeWidth="1.3" />
      <path d="m10 10 2 2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}
